export default "__VITE_ASSET__CY4iVNtW__"